/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * The station's visibility:
 *   * HIDDEN: not shown on any map
 *   * PRIVATE: only shown on map for connected users
 *   * PUBLIC: shown on map for everybody
 */
export enum Visibility {
  HIDDEN = 'HIDDEN',
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC'
}
